import GameTableWrapper from "../modules/game/components/game-table/GameTableWrapper";

type mModel = {
    id: number,
    icon: string,
    name: string,
    border: string,
    component: any
}

const stLabel = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    CANCEL: "c",
    "": 0,
    TWO_THREE: "2-3",
    THREE_FOUR: "3-4",
    FOUR_FIVE: "4-5",
}

let gameMenus: mModel[] = [
    {
        id: 0,
        icon: "socdia",
        name: "Xóc Đĩa",
        border: "border_cd",
        component: GameTableWrapper
    },
    {
        id: 1,
        icon: "taixiu",
        name: "Tai Xiu",
        border: "border_tx",
        component: GameTableWrapper
    }
]
export {gameMenus, stLabel}